import { render, staticRenderFns } from "./HospitalWaitingList.vue?vue&type=template&id=6bba1988"
import script from "./HospitalWaitingList.vue?vue&type=script&lang=js"
export * from "./HospitalWaitingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports